const liveListTagData = {
  shareTitle: 'SBS 인기작 무료 정주행 채널 : 24시간 TV',
  shareDescription:
    'SBS 인기 방영작 무료 정주행 채널. 다시봐도 재미있고 감동적인 SBS 화제작을 24시간 끊김없이 초고화질 무료 스트리밍으로 즐기세요!',
  shareImageUrl:
    'https://program-image.cloud.sbs.co.kr/og/2025/sbs_live_24tv.png',
  currentUrl: 'https://www.sbs.co.kr/live?type=24tv',
  keywords:
    'SBS 무료 정주행 채널, SBS 무료 스트리밍 채널, SBS 인기 드라마 무료 스트리밍, SBS 인기 예능 무료 스트리밍, drama free, kdrama free, SBS TV 무료 스트리밍,정주행 스트리밍, TV show free streaming site, free TV streaming site, watch free TV, free TV show online',
};
const liveEndTagData = {
  shareTitle: '무료 정주행 24시간 TV : ',
  shareDescription: '무료 스트리밍',
  shareImageUrl:
    'https://program-image.cloud.sbs.co.kr/og/2025/sbs_live_24tv.png',
  currentUrl: 'https://www.sbs.co.kr/live?type=24tv',
  keywords:
    '무료 스트리밍, 무료 정주행, SBS 무료 정주행 채널, SBS 무료 스트리밍 채널, drama free, kdrama free, SBS TV 무료 스트리밍,정주행 스트리밍, TV show free streaming site, free TV streaming site, watch free TV, free TV show online',
};

export default function index(channelId = '') {
  let result = { ...liveListTagData };

  if (channelId) {
    result = { ...liveEndTagData };
    result.currentUrl += channelId;
  }

  return result;
}
